import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'error-modal',
  templateUrl: './alg-error-modal.component.html',
  styleUrls: ['./alg-error-modal.component.scss']
})
export class AlgErrorModalComponent implements OnInit, OnChanges {

  @ViewChild('error') public error;
  @ViewChild('data') public data;

  @Input() public size = 'default';
  @Input() public isError: boolean = true;
  @Input() public errorMessage: string = '';

  constructor() { }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.isError && changes.isError.currentValue === true) {
      this.error.nativeElement.style.display = 'block';
      this.data.nativeElement.style.visibility = 'visible';
      return;
    }
    this.error.nativeElement.style.display = 'none';
    this.data.nativeElement.style.visibility = 'inherit';
  }
  
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/alg-error-modal/alg-error-modal.component.ts